import React from "react";
import Button from "../../_components/button/Button";
import "./related_products.css";
import { Link } from "react-router-dom";
const mcaProducts = [
  {
    id: 1,
    title: "MCA 525 GEN 2",
    description:
      "5-channel power amplifier; 225 watts per channel continuous power into 8 ohms.",

    imageUrl: "https://cdn.pmlsound.com/anthem/avm90/images/mca525.jpg",
    href: "https://www.anthemav.com/products-current/type=amplifier/model=mca-525-gen2/page=overview",
  },
  {
    id: 2,
    title: "MCA 325 GEN 2",
    description:
      "3-channel power amplifier; 225 watts per channel continuous power into 8 ohms.",

    imageUrl: "https://cdn.pmlsound.com/anthem/avm90/images/mca325.jpg",
    href: "https://www.anthemav.com/products-current/type=amplifier/model=mca-325-gen2/page=overview",
  },
  {
    id: 3,
    title: "MCA 225 GEN 2",
    description:
      "2-channel power amplifier; 225 watts per channel continuous power into 8 ohms.",

    imageUrl: "https://cdn.pmlsound.com/anthem/avm90/images/mc225.jpg",
    href: "https://www.anthemav.com/products-current/type=amplifier/model=mca-225-gen2/page=overview",
  },
  {
    id: 4,
    title: "M1",
    description:
      "Single channel (monaural) power amplifier; 1,000 watts per channel continuous power into 8 ohms.",

    imageUrl: "https://cdn.pmlsound.com/anthem/avm90/images/M1.jpg",
    href: "https://www.anthemav.com/products-current/type=amplifier/model=m1/page=overview",
  },
  {
    id: 5,
    title: "P5",
    description:
      "5-channel power amplifier with 325 watts per channel continuous power into 8 ohms.",

    imageUrl: "https://cdn.pmlsound.com/anthem/avm90/images/statement_p5.jpg",
    href: "https://www.anthemav.com/products-current/type=amplifier/model=p5/page=overview",
  },
  {
    id: 6,
    title: "P2",
    description:
      "2-channel power amplifier with 325 watts per channel continuous power into 8 ohms.",

    imageUrl: "https://cdn.pmlsound.com/anthem/avm90/images/statement_p2.jpg",
    href: "https://www.anthemav.com/products-current/type=amplifier/model=p2/page=overview",
  },
  {
    id: 7,
    title: "STR Power Amplifier",
    description: "Stereo power amplifier with 400W/600W/800W into 8/4/2 ohms.",

    imageUrl: "https://cdn.pmlsound.com/anthem/avm90/images/str-3qtr.png",
    href: "https://www.anthemav.com/products-current/type=amplifier/model=str-power-amplifier/page=overview",
  },
];

const RelatedProducts = (props) => {
  return (
    <section className="z-50 relative" id="related_products">
      <div className="py-16 px-6 md:py-24 bg-white z-50">
        <div className="max-w-7xl mx-auto z-50">
          <h4 className="z-50 text-4xl md:text-5xl lg:text-6xl font-bold text-center text-gray-900 leading-snug">
            Companion Amplifiers
          </h4>

          <div className="mt-20 grid gap-16 md:grid-cols-2 lg:grid-cols-3 z-50">
            {mcaProducts.map((_) => (
              <div
                key={_.id}
                className="flex flex-col rounded-lg shadow-2xl overflow-hidden related-products-background bg-white"
              >
                <div className="flex-shrink-0 p-6">
                  <img
                    className="h-48 w-full object-contain"
                    src={_.imageUrl}
                    alt={_.title}
                  />
                </div>
                <div className="flex-1  p-6 flex flex-col justify-between">
                  <div className="flex-1 mb-5">
                    <p className="text-xl font-semibold text-gray-700">
                      {_.title}
                    </p>
                    <p className="mt-3 text-sm text-gray-500">
                      {_.description}
                    </p>
                  </div>
                  <span onClick={() => window.open(_.href, "_blank")}>
                    {/* <Link
                    to={{
                      pathname: `${_.href}`,
                    }}
                    target="_blank"
                  > */}
                    <Button
                      name="Learn more"
                      dark={true}
                      centered={false}
                      width={"fit"}
                      // handleClick={handleClick}
                    />
                    {/* </Link> */}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RelatedProducts;
